import Button from '@eduzz/houston-ui/Button';
import Tooltip from '@material-ui/core/Tooltip';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import React, { useState } from 'react';
import { tap } from 'rxjs/operators';
import { BackgroundExportModal } from 'v2/components/Shared/BackgroundExportModal';
import financialService from 'v2/services/financial';

import { useStyles } from './styles';

import type { FilterBy } from 'scenes/Producer/FinancialStatement';

interface IProps {
  filterBy: FilterBy;
  itemsCount: number;
}

export const Export = ({ filterBy, itemsCount }: IProps) => {
  const classes = useStyles();

  const [loading] = useState(false);
  const [isExportModalOpen, setIsModalExportOpen] = useState(false);

  const onOk = (email: string, callback: () => void) => financialService.exportBackground(email).pipe(tap(callback));

  const handleOpenExportModal = () => {
    setIsModalExportOpen(true);
  };

  const handleCloseExportModal = () => {
    setIsModalExportOpen(false);
  };

  const isFilteringByMonth = filterBy === 'Month';

  return (
    <>
      <Tooltip title={!isFilteringByMonth ? 'A exportação só é permitida na filtragem por mês' : ''} placement='top'>
        <Button
          id='export-button'
          className={classes.exportBtn}
          onClick={handleOpenExportModal}
          disabled={!itemsCount || !isFilteringByMonth}
          variant='text'
          loading={loading}
          startIcon={<SystemUpdateAltIcon />}
        >
          {!loading ? 'Exportar' : 'Exportando...'}
        </Button>
      </Tooltip>

      <BackgroundExportModal
        reportDescription='extrato'
        open={isExportModalOpen}
        onClose={handleCloseExportModal}
        onOk={onOk}
        message=''
        shouldInformUnregisteredEmail
      />
    </>
  );
};
